import { useContext } from 'react';
import { AuthContext } from '../../authProvider.mjs';
import { SiteFooter } from '../../components/HomeCard.mjs';
import PageShell from '../../components/PageShell.mjs';
import RoleToolCards, { useRoleTools } from '../../components/RoleToolCards.mjs';

/**
 * A staff role's dashboard, opened from the role card on the home page.
 *
 * One page for all five roles - admin, auditor, and the regional, global and
 * finance directors - each on its own route behind its own role guard. The
 * cards come from RoleToolCards: the role's approval work first, then anything
 * delegated to this person, then the role's other tools. (This was the admin's
 * links page; every staff role now gets one.)
 */
const RoleDashboardPage = () => {
  const { user } = useContext(AuthContext);
  const { dashboard } = useRoleTools();

  // The route's role guard has already admitted only this role.
  if (!dashboard) return null;

  // Admins and regional directors work within one region, so the band names
  // it, as the home page does; the other roles see every region.
  const scope = dashboard.regional ? user?.region : 'All regions';
  const subtitle = `${dashboard.label} Functionalities${scope ? ` · ${scope}` : ''}`;

  return (
    <>
      <PageShell title={dashboard.title} subtitle={subtitle} width="7xl" centerContent skyline>
        <RoleToolCards />
      </PageShell>

      <SiteFooter />
    </>
  );
};

export default RoleDashboardPage;
